import React from 'react';
import {useTecRmi} from "contexts/TecRmiContext";
import {InputGroup, InputGroupAddon, InputGroupText} from "reactstrap";
import Icon from "componentsReusable/Icon";
import InputText from "componentsReusable/AppTable/InputText";
import {useTranslation} from "react-i18next";

const WorkTimeMultiplier = () => {
  const { t } = useTranslation('tec_rmi');
  const {workTimeMultiplier, setWorkTimeMultiplier} = useTecRmi()

  const handleDecrease = () => {
    updateWorkTimeMultiplier((workTimeMultiplier - 0.05).toFixed(2))
  }

  const handleIncrease = () => {
    updateWorkTimeMultiplier((workTimeMultiplier + 0.05).toFixed(2))
  }

  const updateWorkTimeMultiplier = (value) => {
    if(value < 0){
      setWorkTimeMultiplier(0)
    }else if(value > 10){
      setWorkTimeMultiplier(10)
    }else{
      setWorkTimeMultiplier(parseFloat(parseFloat(value).toFixed(2)))
    }
  }

  return <InputGroup className="d-flex flex-row flex-nowrap w-auto">
    <InputGroupAddon addonType={'prepend'} className="cursor-pointer">
      <InputGroupText>
        <span className="d-none d-md-block">{t('work_time_multiplier.text')}:</span>
        <Icon className="d-block d-md-none fas fa-info-circle" tooltip={t('work_time_multiplier.text')} />
      </InputGroupText>
    </InputGroupAddon>
    <InputGroupAddon addonType={'prepend'} className="cursor-pointer" onClick={handleDecrease}>
      <InputGroupText className="p-0"><Icon className="fas fa-minus px-3 py-2" /></InputGroupText>
    </InputGroupAddon>
    <InputText
      selectOnFocus
      className="text-center"
      onChanged={_workTimeMultiplier => {
        _workTimeMultiplier = _workTimeMultiplier.replace(',', '.');
        if (!/\d+\.?,?/.test(_workTimeMultiplier)) {
          return
        }

        updateWorkTimeMultiplier(_workTimeMultiplier)
      }}
      onCancel={() => setWorkTimeMultiplier(workTimeMultiplier)}
      value={workTimeMultiplier.toFixed(2)}
      style={{ width: 65 }}
    />
    <InputGroupAddon addonType={'append'} className="cursor-pointer" onClick={handleIncrease}>
      <InputGroupText className="p-0"><Icon className="fas fa-plus px-3 py-2" /></InputGroupText>
    </InputGroupAddon>
  </InputGroup>
};

WorkTimeMultiplier.propTypes = {

};

export default WorkTimeMultiplier;